import { Link } from 'react-router-dom';
import { products } from '../../../mocks/products';

const benefitChips = [
  { icon: 'ri-sun-fill', label: 'Cures in 1–3 min', color: 'bg-[#FF6B35]/10 text-[#FF6B35]' },
  { icon: 'ri-suitcase-2-line', label: 'Travel Safe', color: 'bg-[#0B5C4D]/10 text-[#0B5C4D]' },
  { icon: 'ri-check-double-line', label: 'All Board Types', color: 'bg-emerald-100 text-emerald-700' },
  { icon: 'ri-time-line', label: 'Endless Shelf Life', color: 'bg-amber-100 text-amber-700' },
  { icon: 'ri-leaf-line', label: 'Bio-Resin Option', color: 'bg-emerald-100 text-emerald-700' },
];

const featured = products.slice(0, 5);

export default function ProductOverview() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-4 mb-8">
          <div>
            <p className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest mb-2">Our Range</p>
            <h2 className="text-4xl md:text-5xl font-black text-stone-900 leading-tight">
              Repair Kits for<br />
              <span className="text-[#0B5C4D]">Every Board Type</span>
            </h2>
          </div>
          <Link
            to="/products"
            className="whitespace-nowrap flex items-center gap-2 text-[#0B5C4D] font-bold text-sm border-2 border-[#0B5C4D] px-6 py-3 rounded-full hover:bg-[#0B5C4D] hover:text-white transition-all duration-200 cursor-pointer"
          >
            View All Products
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Benefit chips */}
        <div className="flex flex-wrap gap-2.5 mb-10">
          {benefitChips.map((chip) => (
            <div key={chip.label} className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold ${chip.color}`}>
              <i className={`${chip.icon} text-sm`} />
              {chip.label}
            </div>
          ))}
        </div>

        {/* Asymmetric product grid */}
        <div className="grid grid-cols-12 gap-4">
          {/* Left tall card */}
          <div className="col-span-12 md:col-span-4 group cursor-pointer">
            <Link to={`/products/${featured[0].slug}`}>
              <div className="relative h-[540px] rounded-2xl overflow-hidden">
                <img
                  src={featured[0].image}
                  alt={featured[0].name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B2C26]/85 via-transparent to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="bg-[#FF6B35] text-white text-xs font-bold px-3 py-1 rounded-full">{featured[0].badge}</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="text-white/60 text-xs font-semibold uppercase tracking-wider mb-1">{featured[0].category}</p>
                  <h3 className="text-white font-black text-xl mb-1">{featured[0].name}</h3>
                  <p className="text-[#FF6B35] font-bold mb-3">${featured[0].price}</p>
                  <div className="flex items-center gap-1 text-white/80 text-sm font-semibold group-hover:text-[#FF6B35] transition-colors">
                    Shop Now <i className="ri-arrow-right-line text-sm" />
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* Center two stacked */}
          <div className="col-span-12 md:col-span-4 flex flex-col gap-4">
            {[featured[1], featured[2]].map((product) => (
              <Link to={`/products/${product.slug}`} key={product.id} className="group cursor-pointer">
                <div className="relative h-[260px] rounded-2xl overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-stone-900/75 via-transparent to-transparent" />
                  <div className="absolute top-3 left-3">
                    <span className="bg-white/90 text-[#0B5C4D] text-xs font-bold px-2.5 py-1 rounded-full">{product.badge}</span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-white font-black text-base">{product.name}</h3>
                    <p className="text-[#FF6B35] font-bold text-sm">${product.price}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Right two stacked */}
          <div className="col-span-12 md:col-span-4 flex flex-col gap-4">
            {[featured[3], featured[4]].map((product) => (
              <Link to={`/products/${product.slug}`} key={product.id} className="group cursor-pointer">
                <div className="relative h-[260px] rounded-2xl overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-stone-900/75 via-transparent to-transparent" />
                  <div className="absolute top-3 right-3">
                    <span className="bg-[#FF6B35] text-white text-xs font-bold px-2.5 py-1 rounded-full">{product.badge}</span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-white font-black text-base">{product.name}</h3>
                    <p className="text-white/80 font-bold text-sm">${product.price}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Bundle callout */}
        <div className="mt-8 bg-[#F5EFE6] rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-[#FF6B35]/15 flex items-center justify-center">
              <i className="ri-gift-line text-[#FF6B35] text-xl" />
            </div>
            <div>
              <p className="text-stone-900 font-black text-base">Free Micro Kit on orders over $40</p>
              <p className="text-stone-500 text-sm">Add the Universal Kit to your cart — micro kit added automatically</p>
            </div>
          </div>
          <Link
            to="/products"
            className="whitespace-nowrap bg-[#0B5C4D] text-white font-bold px-6 py-3 rounded-full hover:bg-[#094d3f] transition-colors cursor-pointer flex-shrink-0"
          >
            Claim Offer
          </Link>
        </div>
      </div>
    </section>
  );
}
